import React from 'react';
import { useTranslation } from 'react-i18next';
import './FeaturesSection.css';

const TestimonialCard = ({ companyKey, roleKey, textKey }) => {
  const { t } = useTranslation();

  return (
    <div 
      className="feature-modern testimonial-card"
    >
      <div className="testimonial-logo">
        <span>{t(companyKey)}</span>
      </div>
      <div className="feature-text-modern">
        <h3>{t(roleKey)}</h3>
        <p>{t(textKey)}</p>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <div className="features-modern">
      <TestimonialCard
        companyKey="landing.testimonials.afflight.company"
        roleKey="landing.testimonials.afflight.role"
        textKey="landing.testimonials.afflight.text"
      />
      <TestimonialCard
        companyKey="landing.testimonials.m10.company"
        roleKey="landing.testimonials.m10.role"
        textKey="landing.testimonials.m10.text"
      />
      <TestimonialCard
        companyKey="landing.testimonials.bidmagnet.company"
        roleKey="landing.testimonials.bidmagnet.role"
        textKey="landing.testimonials.bidmagnet.text"
      />
      <TestimonialCard
        companyKey="landing.testimonials.heartbid.company"
        roleKey="landing.testimonials.heartbid.role"
        textKey="landing.testimonials.heartbid.text"
      />
    </div>
  );
};

export default FeaturesSection;

